import React from "react";
import { Props } from "./type";

function UserIcon(props: Props) {
  return (
    <svg className={props.className} viewBox="0 0 13.621 13.621">
      <path d="M6.81,7.662A3.831,3.831,0,1,0,2.98,3.831,3.832,3.832,0,0,0,6.81,7.662Zm3.405.851H8.75a4.631,4.631,0,0,1-3.879,0H3.405A3.4,3.4,0,0,0,0,11.918v.426a1.277,1.277,0,0,0,1.277,1.277H12.344a1.277,1.277,0,0,0,1.277-1.277v-.426A3.4,3.4,0,0,0,10.215,8.513Z" />
    </svg>
  );
}

export { UserIcon };
